import {
  Box,
  Button,
  Grid,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tooltip,
} from "@mui/material";
import { PageHeader } from "../../../../components/PageHeader";
import { useTranslation } from "react-i18next";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { useEffect, useState } from "react";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbsUpDownIcon from "@mui/icons-material/ThumbsUpDown";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import BookmarkRemoveIcon from "@mui/icons-material/BookmarkRemove";
import {
  campaignsRelatedToFollowingKeywords,
  followCampaign,
  getFollowingCampaigns,
  getPopularCampaigns,
  recentKeywordCampaigns,
  unfollowCampaign,
} from "../../../../api/specialization/KeywordSpecializationAPI";
import { Link } from "react-router-dom";
import InfoIcon from "@mui/icons-material/Info";
import { OptionsObject, useSnackbar } from "notistack";
import { errorNoti } from "../../../../util/SnackbarMessage";
import { AlertSuccessProp } from "../../../../components/SnackbarNoti";
import TrendzContainerCard from "../../../../components/TrendzContainerCard";

export default function KeywordCampaignsPage() {
  const { t } = useTranslation(["common", "keyword", "sidebar", "author"]);
  const [currentTab, setCurrentTab] = useState("recent");
  const [campaigns, setCampaigns] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  };

  useEffect(() => {
    if (currentTab == "recent") {
      recentKeywordCampaigns().then((res) => {
        setCampaigns(res.campaigns);
        console.log(campaigns);
      });
    }
    if (currentTab == "relevant") {
      campaignsRelatedToFollowingKeywords().then((res) => {
        setCampaigns(res.campaigns);
        console.log(campaigns);
      });
    }
    if (currentTab == "following") {
      setCampaigns([]);
      getFollowingCampaigns().then((res) => {
        setCampaigns(res.campaigns);
        console.log(campaigns);
      });
    }
    if (currentTab == "popular") {
      getPopularCampaigns().then((res) => {
        setCampaigns(res.campaigns);
        console.log(campaigns);
      });
    }
  }, [currentTab]);

  var rows = campaigns.slice(0, 10).map((campaign) => {
    var sentimentIcon = (
      <ThumbsUpDownIcon color="info" style={{ marginLeft: "8px" }} />
    );
    if (campaign["sentimentType"] == "POSITIVE") {
      sentimentIcon = (
        <ThumbUpAltIcon color="success" style={{ marginLeft: "8px" }} />
      );
    }
    if (campaign["sentimentType"] == "NEGATIVE") {
      sentimentIcon = (
        <ThumbDownAltIcon color="error" style={{ marginLeft: "8px" }} />
      );
    }
    return (
      <TableRow key={campaign["id"]} className="grey-hover cluster-row">
        <TableCell
          style={{
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
          sx={{ fontWeight: "500 !important" }}
        >
          <Link to={"/specialization/campaign/" + campaign["id"]}>
            {campaign["keyword"]}
          </Link>
        </TableCell>
        <TableCell style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          <Tooltip
            title={t("common:" + campaign["sentimentType"].toLowerCase())}
          >
            {sentimentIcon}
          </Tooltip>
        </TableCell>
        <TableCell style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          {campaign["postCount"]}
        </TableCell>
        <TableCell
          style={{
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "10px",
            paddingRight: "10px",
          }}
          sx={{ align: "center" }}
        >
          <Box display={"flex"}>
            <Tooltip title={t("common:see_detail")}>
              <Link to={"/specialization/campaign/" + campaign["id"]}>
                <Button
                  variant="contained"
                  color="info"
                  style={{ marginRight: "10px" }}
                  onClick={() => {}}
                >
                  <InfoIcon />
                </Button>
              </Link>
            </Tooltip>
            <Tooltip title={t("common:follow")}>
              <Button
                variant="contained"
                color="success"
                style={{ marginRight: "10px" }}
                onClick={() => {
                  followCampaign(campaign["id"])
                    .then((res) => {
                      enqueueSnackbar(
                        t("common:update_successfully"),
                        AlertSuccessProp as OptionsObject
                      );
                    })
                    .catch((err) => {
                      var noti = errorNoti(err);
                      enqueueSnackbar(t("error:" + noti.message), noti.option);
                    });
                }}
              >
                <BookmarkIcon />
              </Button>
            </Tooltip>
            {currentTab == "following" ? (
              <Tooltip title={t("common:unfollow")}>
                <Button
                  variant="contained"
                  color="error"
                  style={{ marginRight: "10px" }}
                  onClick={() => {
                    unfollowCampaign(campaign["id"])
                      .then((res) => {
                        enqueueSnackbar(
                          t("common:update_successfully"),
                          AlertSuccessProp as OptionsObject
                        );
                        window.location.reload();
                      })
                      .catch((err) => {
                        var noti = errorNoti(err);
                        enqueueSnackbar(
                          t("error:" + noti.message),
                          noti.option
                        );
                      });
                  }}
                >
                  <BookmarkRemoveIcon />
                </Button>
              </Tooltip>
            ) : (
              ""
            )}
          </Box>
        </TableCell>
      </TableRow>
    );
  });

  return (
    <TrendzContainerCard title={t("keyword:keyword_campaigns")}>
      <Tabs
        value={currentTab}
        onChange={handleChangeTab}
        style={{ marginBottom: "2px" }}
      >
        <Tab
          label={
            <Tooltip title={t("keyword:recent_campaigns")} placement="bottom">
              <div>{t("common:recent")}</div>
            </Tooltip>
          }
          value={"recent"}
        />
        <Tab
          label={
            <Tooltip title={t("keyword:popular_campaigns")} placement="bottom">
              <div>{t("common:popular")}</div>
            </Tooltip>
          }
          value={"popular"}
        />
        <Tab
          label={
            <Tooltip
              title={t("keyword:related_to_keywords_you_follow")}
              placement="bottom"
            >
              <div>{t("common:relevant")}</div>
            </Tooltip>
          }
          value={"relevant"}
        />
        <Tab
          label={
            <Tooltip
              title={t("keyword:campaigns_that_you_are_following")}
              placement="bottom"
            >
              <div>{t("common:following")}</div>
            </Tooltip>
          }
          value={"following"}
        />
      </Tabs>
      <Grid item xs={0.75}></Grid>
      <Grid item xs={10.5} className="white" marginTop={3}>
        <TableContainer component={Paper}>
          <Table>
            <colgroup>
              <col style={{ width: "30%" }} />
              <col style={{ width: "30%" }} />
              <col style={{ width: "30%" }} />
              <col style={{ width: "10%" }} />
            </colgroup>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "600 !important" }}>
                  {t("sidebar:keyword")}
                </TableCell>
                <TableCell sx={{ fontWeight: "600 !important" }}>
                  {t("sidebar:sentiment")}
                </TableCell>
                <TableCell sx={{ fontWeight: "600 !important" }}>
                  {t("author:article_counts")}
                </TableCell>
                <TableCell
                  sx={{
                    align: "center",
                    textAlign: "center",
                    fontWeight: "600 !important",
                  }}
                >
                  {t("common:actions")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{rows}</TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid item xs={0.75}></Grid>
    </TrendzContainerCard>
  );
}
